import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/professional/pro-24.png";
import type { Product } from "../../types";
import { switchingProfessional } from "../product-list-groups/switchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professional24: Product = {
  id: "professional24",
  productTitle: "Pro 24",
  description: "professional24.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-24"],
  storePathParts: {
    productSlug: "usw-pro-24",
    category: "switching-professional",
  },
  sku: "USW-Pro-24",
  image: { src: image, width: 200, height: 140 },
  productListGroup: switchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 285 x 44 mm\n(17.4 x 11.2 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "24" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
